export const API_EXTERNAL_ENDPOINT = 'pueblos-landings/:slug'

export const API_INTERNAL_ENDPOINT = 'strapi/pueblos-landings/detail'
